// =============================================================================
// Request & Response Model
// =============================================================================
import { AxiosError } from 'axios';
import { FileUploadState } from '../../models/File';
import axiosClient from '../axiosClient';
import { GET_DOCUMENT_UPLOAD_STATUS_URL } from '../../constants/apiUrls';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_FILE_UPLOAD_STATUS_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

export interface GetDocumentUploadStatusResponse {
  fileStatus: FileUploadState;
  url?: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: GetDocumentUploadStatusResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  fileKey: string;
  refetchInterval: number | undefined;
  enabled?: boolean;
}

export const useGetNotificationReportDocument = ({
  fileKey,
  enabled = false,
  onSuccess,
  onError,
  refetchInterval,
}: Input) => {
  const getDocumentUploadStatus = async () => {
    const res = await axiosClient.get<GetDocumentUploadStatusResponse>(
      GET_DOCUMENT_UPLOAD_STATUS_URL(fileKey)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_FILE_UPLOAD_STATUS_QUERY_KEY, fileKey],
    getDocumentUploadStatus,
    {
      onSuccess,
      onError,
      retryOnMount: true,
      refetchOnWindowFocus: true,
      cacheTime: 0,
      refetchInterval,
      enabled,
    },
    false
  );
};
